/**
 * Image Info Banner - Speech bubble toggle
 * Handles open/close of info bubbles on product gallery images.
 */
(function () {
  function closeAllBubbles(except) {
    document.querySelectorAll('.image-info-banner.is-expanded').forEach((banner) => {
      if (banner !== except) {
        banner.classList.remove('is-expanded');
        const toggle = banner.querySelector('.image-info-banner__toggle');
        const bubble = banner.querySelector('.image-info-banner__bubble');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (bubble) bubble.setAttribute('aria-hidden', 'true');
      }
    });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.image-info-banner__toggle');

    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      const banner = toggle.closest('.image-info-banner');
      const bubble = banner.querySelector('.image-info-banner__bubble');
      const isExpanded = banner.classList.contains('is-expanded');

      // Close all other bubbles
      closeAllBubbles(banner);

      // Toggle current
      banner.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      if (bubble) bubble.setAttribute('aria-hidden', String(isExpanded));

      return;
    }

    // Click outside - close all bubbles
    if (!event.target.closest('.image-info-banner__bubble')) {
      closeAllBubbles();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllBubbles();
    }
  });
})();
